import React from "react";
import { useAppStore } from "@/store/useAppStore";
import { useAuth } from "@/hooks/useAuth";

export const ChallengesCards = () => {
  const { quickChallenges, completedChallenges, setSelectedChallenge, setActiveModal, setIsModalOpen } =
    useAppStore();
    const {user} = useAuth()

    const clickChallengeCard = (isCompleted: boolean, challenge: any) => {
      if (!user?.email) {
        setIsModalOpen(true);
        setActiveModal("auth")
      } else {
        !isCompleted && setSelectedChallenge(challenge)
      }
    }
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      {quickChallenges.map((challenge) => {
        const isCompleted = completedChallenges.includes(challenge.id);
        return (
          <div
            key={challenge.id}
            className={`rounded-lg p-5 cursor-pointer transition-colors ${
              isCompleted
                ? "bg-[#0A1A0A] border border-[#1A3A1A]"
                : "bg-[#1C1C1E] hover:bg-[#2A2A2E]"
            }`}
            onClick={() => clickChallengeCard(isCompleted, challenge)}
          >
            <div className="flex justify-between items-start mb-3">
              <h3 className="text-base font-medium text-white leading-snug">
                {challenge.title}
              </h3>
              <span className="text-xs text-[#808080] ml-4 shrink-0">
                +{challenge.points} pts
              </span>
            </div>
            <p className="text-sm text-[#808080] mb-4 leading-relaxed">{challenge.description}</p>
            <div className="flex justify-between items-center text-sm">
              <span className="text-[#4D4A46]">{challenge.timeToComplete}</span>
              <span
                className={`font-medium ${
                  isCompleted ? "text-green-500" : "text-[#CCFF00]"
                }`}
              >
                {isCompleted ? "Completed" : "Play"}
              </span>
            </div>
          </div>
        );
      })}
    </div>
  );
};
